// src/hooks/useNotasCotizacion.js
import { useState, useEffect } from "react";
import { collection, addDoc, deleteDoc, doc, onSnapshot, query, where, serverTimestamp } from "firebase/firestore";
import { db, auth } from "../firebase";
import toast from "react-hot-toast";

const COL = "notasCotizacion";

// Hook para notas de UNA cotización específica
export function useNotasCotizacion(cotizacionId) {
  const [notas,   setNotas]   = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!cotizacionId) { setNotas([]); setLoading(false); return; }
    const q = query(collection(db, COL), where("cotizacionId", "==", cotizacionId));
    const unsub = onSnapshot(q, snap => {
      const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      list.sort((a, b) => {
        const fa = a.creadoEn?.toDate ? a.creadoEn.toDate() : new Date(a.creadoEn || 0);
        const fb = b.creadoEn?.toDate ? b.creadoEn.toDate() : new Date(b.creadoEn || 0);
        return fb - fa; // más reciente primero
      });
      setNotas(list);
      setLoading(false);
    });
    return unsub;
  }, [cotizacionId]);

  const eliminarNota = async (id) => {
    try { await deleteDoc(doc(db, COL, id)); }
    catch { toast.error("Error al eliminar nota"); }
  };

  return { notas, loading, eliminarNota };
}

// Función standalone para agregar una nota (se puede llamar sin el hook)
export async function agregarNotaCotizacion({ cotizacionId, cotizacionNum, clienteNombre, texto, tipo = "Nota" }) {
  if (!texto?.trim()) return;
  try {
    await addDoc(collection(db, COL), {
      cotizacionId,
      cotizacionNum: cotizacionNum || "",
      clienteNombre: clienteNombre || "",
      texto: texto.trim(),
      tipo,        // "Nota" | "Seguimiento" | "Estado"
      fecha: (() => { const d=new Date(); return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,"0")}-${String(d.getDate()).padStart(2,"0")}`; })(),
      autor: auth.currentUser?.email || "",
      creadoEn: serverTimestamp(),
    });
  } catch {
    toast.error("Error al guardar nota");
  }
}
